export default {
  name: "server-maintenance",
};
